const nl2br = (str, tag='<br>') =>
{
	if ( typeof(str) === 'undefined' || str === null )
	{
		return ''
	}

	return ( str + '' ).replace(/(\r\n|\n\r|\r|\n)/g, tag + '$1')
}

export default nl2br